module.exports = __webpack_public_path__ + "public/SiteImages/main-v2.png?f839e0e4";


//////////////////
// WEBPACK FOOTER
// ./public/SiteImages/main-v2.png
// module id = 3313
// module chunks = 8